
export const colors = {
    "Exceeds Mastery": "#ECEAF5",
    "Mastered": "#D2CFE8",
    "Approaches Mastery": "#ACA5D5",
    "Not Mastered": "#710F0F",
}
